import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  image, 
  url,
  type = 'website',
  product = null,
  noIndex = false 
}) => {
  const siteName = 'VAV Wear Tactical & Outdoor';
  const defaultDescription = 'Premium taktik ve outdoor giyim. Zorlu koşullar için tasarlandı. Askeri standartlarda kalite, profesyonel performans.';
  const defaultImage = 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=1200';

  const seoTitle = title ? title + ' | ' + siteName : siteName;
  const seoDescription = description || defaultDescription;
  const seoImage = image || defaultImage;
  const seoUrl = url || (typeof window !== 'undefined' ? window.location.href : '');

  useEffect(() => {
    // Update document title
    document.title = seoTitle;

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Basic meta tags
    updateMetaTag('description', seoDescription);
    if (noIndex) {
      updateMetaTag('robots', 'noindex, nofollow');
    }

    // Open Graph tags
    updateMetaTag('og:type', type, true);
    updateMetaTag('og:url', seoUrl, true);
    updateMetaTag('og:title', seoTitle, true);
    updateMetaTag('og:description', seoDescription, true);
    updateMetaTag('og:image', seoImage, true);
    updateMetaTag('og:site_name', siteName, true);
    updateMetaTag('og:locale', 'tr_TR', true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:url', seoUrl);
    updateMetaTag('twitter:title', seoTitle);
    updateMetaTag('twitter:description', seoDescription);
    updateMetaTag('twitter:image', seoImage);

    // Update canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', seoUrl);

    // Product schema for product pages
    if (product) {
      let schemaScript = document.querySelector('script[data-schema="product"]');
      if (!schemaScript) {
        schemaScript = document.createElement('script');
        schemaScript.setAttribute('type', 'application/ld+json');
        schemaScript.setAttribute('data-schema', 'product');
        document.head.appendChild(schemaScript);
      }
      schemaScript.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": product.name,
        "description": product.description,
        "image": product.images?.[0] || seoImage,
        "brand": {
          "@type": "Brand",
          "name": product.brand || "VAV Wear"
        },
        "offers": {
          "@type": "Offer",
          "url": seoUrl,
          "priceCurrency": product.currency || "TRY",
          "price": product.price,
          "availability": product.variants?.some(v => v.stock > 0) 
            ? "https://schema.org/InStock" 
            : "https://schema.org/OutOfStock"
        },
        "category": product.category
      });
    }

    // Cleanup on unmount
    return () => {
      // Keep meta tags but clean up schema if needed
    };
  }, [seoTitle, seoDescription, seoImage, seoUrl, type, noIndex, product, siteName]);

  return null; // This component doesn't render anything
};

export default SEO;
